import { ScanDataFundingSource } from '@occc/graphql';

import { SelectData } from '@occc-app/design-system';

export const SCAN_DATA_PLACEMENT_SELECT_ITEMS: Array<SelectData<ScanDataFundingSource>> = [
  {
    value: ScanDataFundingSource.DigitalAcceleratorFund,
    label: 'Digital Accelerator Fund (Fields 27–28)',
  },
  {
    value: ScanDataFundingSource.OutletLoyalty,
    label: 'Outlet Funded – Loyalty (Fields 40–41)',
  },
];
